import { render, staticRenderFns } from "./max_transformer_load.vue?vue&type=template&id=6126e61c&scoped=true&"
import script from "./max_transformer_load.vue?vue&type=script&lang=js&"
export * from "./max_transformer_load.vue?vue&type=script&lang=js&"
import style0 from "./max_transformer_load.vue?vue&type=style&index=0&id=6126e61c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126e61c",
  null
  
)

export default component.exports